import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'app/App.store';
import { useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import Titulos from './common/enums/titulos.enum';

export interface MainNavState {
    optionActive: string;
    isLoadingFirstMenu: boolean;
}

const initialState: MainNavState = {
    optionActive: Titulos.INICIO_TRABAJADOR,
    isLoadingFirstMenu: false
};

export const mainNavSlice = createSlice({
    name: 'mainNav',
    initialState,
    reducers: {
        setOptionActive: (state, { payload }: PayloadAction<string>) => {
            state.optionActive = payload;
        },
        isLoadingFirstMenu(state, { payload }: PayloadAction<boolean>) {
            state.isLoadingFirstMenu = payload;
        }
    }
});

export const { setOptionActive, isLoadingFirstMenu } = mainNavSlice.actions;

export const useMainNavSelector = () =>
    useSelector<AppState, MainNavState>(
        ({ [mainNavSlice.name]: slice }) => slice
    );

export const setItemActive =
    (item: string) =>
    // eslint-disable-next-line require-await
    async (dispatch: Dispatch): Promise<void> => {
        dispatch(setOptionActive(item));
    };
